import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuthApi } from "../hooks/useAuthApi";
import useApiHelper from "../hooks/useApiHelper";
import { useAuth } from "../contexts/AuthContext";

export default function useWilmaUsers() {
  const queryClient = useQueryClient();
  const { token } = useAuth();
  const { getUsers, updateUser, createUser, deleteUser } = useAuthApi();
  const { post, put } = useApiHelper();

  const wilmaUsers = useQuery({
    enabled: !!token,
    queryKey: ["wilmaUsers"],
    queryFn: () => getUsers(token!),
    staleTime: 1000 * 60 * 10,
  });

  const update = useMutation({
    mutationFn: updateUser,
    onSettled: () => {
      localStorage.removeItem("wilmaUsers");
      localStorage.removeItem("wilmaUsersExp");
      queryClient.invalidateQueries(["wilmaUsers"]);
    }
  });

  const updatePassword = useMutation({
    mutationFn: (data: { userId: string; password: string }) =>
      put(`/user/${data.userId}/password`, {
        password: data.password,
      }),
    onSettled: () => queryClient.invalidateQueries(["wilmaUsers"]),
  });

  const create = useMutation({
    mutationFn: createUser,
    onSettled: () => {
      localStorage.removeItem("wilmaUsers");
      localStorage.removeItem("wilmaUsersExp");
      queryClient.invalidateQueries(["wilmaUsers"]);
    }
  });

  const remove = useMutation({
    mutationFn: deleteUser,
    onSettled: () => {
      localStorage.removeItem("wilmaUsers");
      localStorage.removeItem("wilmaUsersExp");
      queryClient.invalidateQueries(["wilmaUsers"]);
    }
  });

  return {
    wilmaUsers,
    update,
    create,
    remove,
    updatePassword,
  };
}
